/**
 * Token buying configuration - ratio at top for easy maintenance (like currency exchange)
 */

// Exchange rate: how many tokens per 1 currency unit (must match server REGULAR_PRICING.tokensPerUnit)
export const TOKENS_PER_EURO = 100;

// Min/max payment in euros
export const MIN_PAYMENT_EURO = 1;
export const MAX_PAYMENT_EURO = 100;

// Route for token buying (without packages)
export const TOKEN_BUY_BASE = '/buy';
export const TOKEN_BUY_ROUTE = `${TOKEN_BUY_BASE}/tokens`;
export const TOKEN_BUY_PATH = 'tokens';

// Dedicated payment iframe route (with SSE progress)
export const PAYMENT_PATH = 'payment';
export const PAYMENT_ROUTE = `${TOKEN_BUY_BASE}/${PAYMENT_PATH}`;

// Standalone payment redirect - own URL, shows SSE only, redirects parent. Not the Tranzila iframe.
export const PAYMENT_REDIRECT_PATH = 'payment-redirect';
export const PAYMENT_REDIRECT_ROUTE = `/${PAYMENT_REDIRECT_PATH}`;
